export * from './remitos-home.component';
export * from './remitos-filtros-dialog';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/remitos-home/index.ts